module.exports = __webpack_public_path__ + "static/media/vimeo-selfie.0f45fb11.jpg";